module.exports = __webpack_public_path__ + "static/media/grain-gradient.5d33eb5c.png";